import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";
import LandingPage from "@/pages/LandingPage";
import AccessCode from "@/pages/AccessCode";
import PrivacyConsent from "@/pages/PrivacyConsent";
import InvestigationTypeSelect from "@/pages/InvestigationTypeSelect";
import Questionnaire from "@/pages/Questionnaire";
import PhotoUpload from "@/pages/PhotoUpload";
import Summary from "@/pages/Summary";
import ThankYou from "@/pages/ThankYou";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import InstallPage from "@/pages/InstallPage";

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-cyber-black">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/access" element={<AccessCode />} />
            <Route path="/privacy" element={<PrivacyConsent />} />
            <Route path="/select-type" element={<InvestigationTypeSelect />} />
            <Route path="/questionnaire" element={<Questionnaire />} />
            <Route path="/photos" element={<PhotoUpload />} />
            <Route path="/summary" element={<Summary />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/install" element={<InstallPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" />
      </div>
    </LanguageProvider>
  );
}

export default App;
